import { DeeplinkLoggerEventName } from '@/constants/logs/deeplink';
import { useAirbridgeDynamicLink } from '@/shared/hooks';
import { Tablet } from '@/styles/layout';
import styled, { css } from 'styled-components';

const BottomBanner = () => {
  const airbridgeDynamicLink = useAirbridgeDynamicLink();
  return (
    <Section>
      <BottomBannerImg src={'https://file.doctornow.co.kr/landing/bottom_banner.png'} alt={'하단 배너'} />

      <Content>
        <MainCopyContainer>
          <h2 className='flex flex-col gap-[6px]'>
            <MainCopyHighlightText>
              600만<MainCopyText>이 선택한 </MainCopyText>
            </MainCopyHighlightText>
            <MainBottomCopyText>대한민국 1위 비대면 진료 앱</MainBottomCopyText>
          </h2>
          <MainPrizeText>{'2025 한국소비자만족지수 비대면 진료앱 1위'}</MainPrizeText>
        </MainCopyContainer>
        <DownloadButton
          onClick={() => {
            airbridgeDynamicLink.navigateWithTracking(DeeplinkLoggerEventName.ClickCtaButton, {
              campaign: 'web_home',
              content: 'web_content_bnr_main',
              term: '앱 다운로드',
            });
          }}
        >
          앱 다운로드
        </DownloadButton>
      </Content>
    </Section>
  );
};

export default BottomBanner;

const Section = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 488px;

  background: linear-gradient(86deg, #ff7501 28.16%, #ff8a01 96.29%);
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${Tablet}) {
    overflow: hidden;
    background: linear-gradient(19deg, #ff7501 37.98%, #ff8801 96.07%);
    height: 866px;
  }
`;

const Content = styled.div`
  width: 1080px;
  display: flex;
  flex-direction: column;
  gap: 53px;
  padding: 0 20px;
  white-space: pre-wrap;

  @media screen and (max-width: ${Tablet}) {
    width: 300px;
    align-items: center;
    align-self: flex-start;
    margin-top: 72px;
    gap: 40px;
  }
`;

const MainCopyContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;

  @media screen and (max-width: ${Tablet}) {
    gap: 0;
  }
`;

const MainPrizeText = styled.p`
  ${({ theme }) => css`
    ${theme.typography.UI13M};
    color: ${theme.color.primary300};
  `}
`;

const MainCopyText = styled.span`
  display: flex;
  flex-direction: row;
  ${({ theme }) => `
      ${theme.typography.UI56B};
      color: ${theme.color.white};
      
      @media screen and (max-width: ${Tablet}) { 
        text-align: center;
          justify-content: center;

        ${theme.typography.UI36B};
      } 
    `}
`;

const MainBottomCopyText = styled(MainCopyText)`
  margin-bottom: 26px;
  @media screen and (max-width: ${Tablet}) {
    margin-bottom: 20px;
  }
`;

const MainCopyHighlightText = styled(MainCopyText)`
  color: #fff931;
`;

const DownloadButton = styled.button`
  width: 200px;
  height: 56px;
  border-radius: 12px;
  padding: 0 12px;

  ${({ theme }) => `
    background: ${theme.color.white};
    color: ${theme.color.primary600};
    ${theme.typography.UI17SB};
  `}
`;

const BottomBannerImg = styled.img`
  position: absolute;
  right: 30%;
  bottom: -1px;
  width: 520px;
  object-fit: contain;
  transform: translateX(50%);
  @media screen and (max-width: ${Tablet}) {
    right: 50%;
  }
`;
